import { Injectable } from '@angular/core';
import { CrudService } from '@app/api/api-services/crud.service';
import { ProgramApiModel } from '@app/api/api-models';

@Injectable()
export class ProgramsService extends CrudService<ProgramApiModel, number> {
  public readonly apiUrl = 'programs';
}
